import { render, staticRenderFns } from "./DashboardIsfpPsfpTop10PsfpSimulador.vue?vue&type=template&id=0c4a605f&scoped=true&"
import script from "./DashboardIsfpPsfpTop10PsfpSimulador.vue?vue&type=script&lang=js&"
export * from "./DashboardIsfpPsfpTop10PsfpSimulador.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIsfpPsfpTop10PsfpSimulador.vue?vue&type=style&index=0&id=0c4a605f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a605f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VIcon,VProgressCircular,VSpacer,VTooltip})
